import ToastHighLighter from '@/lib/ToastHighLighter';

export const DropdownCode = () => {
  const language = 'html';
  const codeString = `
  // Large Dropdown
  <div class="dropdown">
    <button
      class="btn btn-secondary dropdown-toggle"
      type="button"
      id="dropdownMenuButton1"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      Large Dropdown
    </button>
    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
      <li>
        <a class="dropdown-item" href="#">
          Action
        </a>
      </li>
      <li>
        <a class="dropdown-item" href="#">
          Another action
        </a>
      </li>
      <li>
        <a class="dropdown-item" href="#">
          Something else here
        </a>
      </li>
    </ul>
  </div>

  // Large Split Dropdown
  <div class="btn-group">
    <button class="btn btn-secondary btn-lg" type="button">
      Large Split Dropdown
    </button>
    <button
      type="button"
      class="btn btn-lg btn-secondary dropdown-toggle dropdown-toggle-split"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <span class="visually-hidden">Toggle Dropdown</span>
    </button>
    <ul class="dropdown-menu">
      <li>
        <a class="dropdown-item" href="#">
          Action
        </a>
      </li>
      <li>
        <a class="dropdown-item" href="#">
          Another action
        </a>
      </li>
      <li>
        <a class="dropdown-item" href="#">
          Something else here
        </a>
      </li>
    </ul>
  </div>

  // Small Dropdown
  <div class="btn-group">
    <button
      class="btn btn-secondary btn-sm dropdown-toggle"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      Small dropdown
    </button>
    <ul class="dropdown-menu">
      <li>
        <a class="dropdown-item" href="#">
          Action
        </a>
      </li>
      <li>
        <a class="dropdown-item" href="#">
          Another action
        </a>
      </li>
      <li>
        <a class="dropdown-item" href="#">
          Something else here
        </a>
      </li>
    </ul>
  </div>

  // Small Split Dropdown
  <div class="btn-group">
    <button class="btn btn-secondary btn-sm" type="button">
      Small split dropdown
    </button>
    <button
      type="button"
      class="btn btn-lg btn-secondary dropdown-toggle dropdown-toggle-split"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <span class="visually-hidden">Toggle Dropdown</span>
    </button>
    <ul class="dropdown-menu">
      <li>
        <a class="dropdown-item" href="#">
          Action
        </a>
      </li>
      <li>
        <a class="dropdown-item" href="#">
          Another action
        </a>
      </li>
      <li>
        <a class="dropdown-item" href="#">
          Something else here
        </a>
      </li>
    </ul>
  </div>
  `;

  return (
    <>
      <ToastHighLighter
        name={'dropdown'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
